import { render, staticRenderFns } from "./RentalPeriodSelector.vue?vue&type=template&id=03fd89d2&"
import script from "./RentalPeriodSelector.vue?vue&type=script&lang=js&"
export * from "./RentalPeriodSelector.vue?vue&type=script&lang=js&"
import style0 from "./RentalPeriodSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!C:/Projects/rentmagic.website.vue.limburg/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol} from 'bootstrap-vue'
    installComponents(component, {BCol})
    

export default component.exports